function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B6DC303A-7662-4FCB-9DEE-3497B53FF546");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDCF1-Tablet",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products",
  transform: "translate(-807.000000, -386.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(536.000000, 250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Elements/Card/Icon+Text",
  transform: "translate(206.000000, 96.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "card"
}, /*#__PURE__*/React.createElement("g", {
  id: "illustrations/lenses",
  transform: "translate(65.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "contactlens",
  transform: "translate(-0.000000, -0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bound",
  x: 0,
  y: 0,
  width: 56,
  height: 56
}), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(9.333333, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "lens",
  transform: "translate(0.000000, 7.896310)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.47974325,4.50679108 C2.04293382,6.98906825 -2.37582115,18.655771 7.68912074,28.8331074 C17.7540626,39.0104438 29.2919229,33.549434 31.255814,31.0671568",
  id: "Path-2",
  fill: "#4072EE"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#9FB8F6",
  transform: "translate(18.066852, 18.108527) rotate(-45.000000) translate(-18.066852, -18.108527) ",
  cx: 18.0668523,
  cy: 18.1085271,
  rx: 6.94573643,
  ry: 18.6046512
})), /*#__PURE__*/React.createElement("g", {
  id: "drop",
  transform: "translate(16.868217, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.96511628,0 C12.3147603,0 19.2984496,11.0833333 19.2984496,15.9703704 C19.2984496,21.2752873 15.1143985,25.6666667 9.96511628,25.6666667 C4.81531602,25.6666667 0.631782946,21.2752873 0.631782946,15.9703704 C0.631782946,11.0833333 7.61547226,0 9.96511628,0 Z",
  id: "Path",
  fill: "#4072EE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.609619,17.0217549 C4.08026724,16.9121193 4.55068029,17.2047778 4.66031595,17.675426 C5.10538301,19.5860273 6.67778961,21.0627764 8.62203367,21.3847175 C9.09879093,21.4636622 9.42128173,21.9141476 9.34233703,22.3909049 C9.26339233,22.8676621 8.81290689,23.1901529 8.33614963,23.1112082 C5.69307337,22.6735497 3.561399,20.671556 2.95594789,18.0724519 C2.84631223,17.6018037 3.13897075,17.1313906 3.609619,17.0217549 Z",
  id: "Path",
  fill: "#FFFFFF"
}))))))))));

var SvgContactlens = function SvgContactlens(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactlens, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contactlens.dd8a698e.svg";
export { ForwardRef as ReactComponent };